var UpdateSkipLinkForSidebarNav = {
    version: '1.0',
    author: 'CAA Digital',
    project: 'WCAG',
    Date: 'Sep 2020',

    //initialization 
    init: function () {
        var context = this;
        //Global variables
        context.config = {
            sidebarNavigationMenu: document.querySelector('.sidebar'),
            sidebarNavPageContentBlock: document.querySelector('#sr_content_main'),
            skipLinkAnchor : document.querySelectorAll('.skip-link'),
            pageBannerExists : document.querySelectorAll("section + .container-fluid").length ? true : false
        };

        //Call DOM invoking functions here
        context.onDomReady();
        context.eventHandlers();

    },

    onDomReady: function () {
        var context = this;

        //Load all functions
        var sideNav = context.config.sidebarNavigationMenu,
        skipLink = context.config.skipLinkAnchor,
        mainContentBlock = context.config.sidebarNavPageContentBlock,
        boolPageBannerExists = context.config.pageBannerExists;

        if (sideNav && mainContentBlock && skipLink.length && !boolPageBannerExists) {
            sideNav.setAttribute("tabindex", "-1");
            for (i = 0; i < skipLink.length; i++) {
                skipLink[i].setAttribute("href", "#sidebar-navigation");
            }
        }

    },

    //Handle all page level events
    eventHandlers: function () {
        var context = this;

        // All event functions here
    },
};

window.addEventListener("load", function () {
    UpdateSkipLinkForSidebarNav.init();
});